import React, { useMemo } from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import styles from './style'
import CustomText from 'components/atoms/CustomText'
import Warning from 'assets/svg/Warning'
import { error, errorSec, yellowFour, yellowSec } from 'theme/colors'
import useNavigation from 'hooks/useNavigation'
import EmptyCabinetSVG from 'assets/svg/EmptyCabinetSVG'
import { InvestmentStatus } from '../types'

interface BoxStatusProps {
  statusId?: InvestmentStatus
}

const BoxStatus: React.FC<BoxStatusProps> = ({ statusId }) => {
  const { onNavigate } = useNavigation()

  const handleHelp = () => {
    onNavigate('/content/customer-support')
  }

  const rejectedStates = [InvestmentStatus.OPENING_REJECTED]

  const suspendedStates = [
    InvestmentStatus.SUSPENDED,
    InvestmentStatus.ACCOUNT_CLOSED,
    InvestmentStatus.ACCOUNT_BLOCKED
  ]

  const values = useMemo(() => {
    if (!statusId) {
      return {
        alertTitle: 'Cuenta pendiente de aprobación',
        alertText:
          'Una vez que tu cuenta esté aprobada, podrás comenzar a invertir.',
        showButton: false,
        color: `${yellowFour}`,
        backgroundColor: `${yellowSec}`
      }
    }

    if (rejectedStates.includes(statusId)) {
      return {
        alertTitle: 'Cuenta rechazada',
        alertText:
          'Tu cuenta no fue aprobada para realizar inversiones. Por favor, contáctanos para solucionarlo.',
        showButton: true,
        color: `${error}`,
        backgroundColor: `${errorSec}`
      }
    }

    if (suspendedStates.includes(statusId)) {
      return {
        alertTitle: 'Cuenta suspendida',
        alertText:
          'Tuvimos que suspender tu cuenta. Por favor, contáctanos para solucionarlo.',
        showButton: true,
        color: `${error}`,
        backgroundColor: `${errorSec}`
      }
    }

    return {
      alertTitle: 'Cuenta pendiente de aprobación',
      alertText:
        'Una vez que tu cuenta esté aprobada, podrás comenzar a invertir.',
      showButton: false,
      color: `${yellowFour}`,
      backgroundColor: `${yellowSec}`
    }
  }, [statusId])

  return (
    <View style={styles.background}>
      <View
        style={[
          styles.container,
          { borderColor: values.color, backgroundColor: values.backgroundColor }
        ]}
      >
        <View style={styles.titleContainer}>
          <Warning style={styles.warning} color={values.color} />
          <Text style={styles.title}>{values.alertTitle}</Text>
        </View>
        <Text style={styles.description}>{values.alertText}</Text>
        {values.showButton && (
          <TouchableOpacity onPress={handleHelp} activeOpacity={0.7}>
            <CustomText
              align="left"
              weight="mediumfont"
              size="xmedium"
              color="black"
              customStyle={{
                textDecorationLine: 'underline'
              }}
            >
              Necesito ayuda
            </CustomText>
          </TouchableOpacity>
        )}
      </View>
      <View style={styles.emptyMovementsContainer}>
        <EmptyCabinetSVG />
        <Text style={styles.emptyMovements}>
          Aún no tenés inversiones
          {'\n'}
          registradas
        </Text>
      </View>
    </View>
  )
}

export default BoxStatus

BoxStatus.defaultProps = {
  statusId: 2
}
